module.exports = __webpack_public_path__ + "static/assets/14ff92731b3e54b249ce2d428a3f0f95.png";